import {
  GET_CUSTOMER,
  GET_CUSTOMER_OPTION_USERS,
  POST_CUSTOMER,
  POST_CUSTOMER_MANAGER,
  GET_CUSTOMER_DETAILS,
  POST_EDIT_CUSTOMER,
  GET_MANAGER_INFO,
  POST_EDIT_MANAGER_INFO,
  POST_EDIT_NAMECARD,
  DEL_CUSTOMER,
  DEL_CUSTOMER_MANAGER,
  POST_ACC_FILE,
  GET_NEWS_DAUM,
  GET_NEWS_GOOGLE,
  GET_NEWS_NAVER,
  GET_CUSTOMER_NEEDS,
  GET_CUSTOMER_FEEDBACK,
  GET_CUSTOMER_LOGS
} from '../../constants/actionTypes';

import { fetchActionGenerator } from '../utils';

export const postCustomer = fetchActionGenerator(POST_CUSTOMER, 'body'); //액션함수 ? 
export const getAllCustomer = fetchActionGenerator(GET_CUSTOMER, 'body', 'pageno')
export const getUsers = fetchActionGenerator(GET_CUSTOMER_OPTION_USERS, 'body')
export const postCustomerManger = fetchActionGenerator(POST_CUSTOMER_MANAGER, 'body')
export const getCustomerDetails = fetchActionGenerator(GET_CUSTOMER_DETAILS, 'body')
export const postEditCustomer = fetchActionGenerator(POST_EDIT_CUSTOMER, 'body')
export const deleteCustomer = fetchActionGenerator(DEL_CUSTOMER, 'body')
export const getManagerInfo = fetchActionGenerator(GET_MANAGER_INFO, 'body')
export const postEditManager = fetchActionGenerator(POST_EDIT_MANAGER_INFO, 'body')
export const postEditNamecard = fetchActionGenerator(POST_EDIT_NAMECARD, 'body')
export const deleteCustomerManager = fetchActionGenerator(DEL_CUSTOMER_MANAGER, 'body')
export const postAccFile = fetchActionGenerator(POST_ACC_FILE, 'body') 
export const getNaverNews = fetchActionGenerator(GET_NEWS_NAVER, 'body')
export const getDaumNews = fetchActionGenerator(GET_NEWS_DAUM, 'body')
export const getGoogleNews = fetchActionGenerator(GET_NEWS_GOOGLE, 'body')
export const getCustomerNeeds = fetchActionGenerator(GET_CUSTOMER_NEEDS, 'body')
export const getCustomerFeedbacks = fetchActionGenerator(GET_CUSTOMER_FEEDBACK, 'body')
export const getCustomerLogs = fetchActionGenerator(GET_CUSTOMER_LOGS, 'body')

